export const SEMAFORO_COLORS = {
  green: "#52c41a",
  yellow: "#faad14",
  red: "#ff4d4f",
  greenBg: "#baffcd",
  yellowBg: "#f8ffba",
  redBg: "#ffbaba",
  blue: "#1890ff",
};

export const COLOR_ORDER = {
  "semaforo__rojo": 1,
  "semaforo__amarillo": 2,
  "semaforo__verde": 3,
  "semaforo__blanco": 4,
};

export const STATUS_MAP = [
  { estatusId: 2, nombre: "Proceso", fechaCampo: "fechaEnProceso" },
  { estatusId: 3, nombre: "Negociando", fechaCampo: "fechaNegociando" },
  { estatusId: 4, nombre: "En Documentación", fechaCampo: "fechaEnDocumentacion" },
  { estatusId: 5, nombre: "Documentado", fechaCampo: "fechaDocumentado" },
  { estatusId: 6, nombre: "Pagado", fechaCampo: "fechaPagado" },
];

export const SEMAFORO_RULES = {
  2: {
    nombre: "En proceso",
    verde: { min: 0, max: 24 },
    amarillo: { min: 24, max: 48 },
    rojo: { min: 48, max: Infinity },
  },
  3: {
    nombre: "Negociando",
    verde: { min: 0, max: 48 },
    amarillo: { min: 48, max: 72 },
    rojo: { min: 72, max: Infinity },
  },
  4: {
    nombre: "En Documentación",
    verde: { min: 0, max: 48 },
    amarillo: { min: 48, max: 72 },
    rojo: { min: 72, max: Infinity },
  },
  5: {
    nombre: "Documentado",
    verde: { min: 0, max: 48 },
    amarillo: { min: 48, max: 72 },
    rojo: { min: 72, max: Infinity },
  },
  6: {
    nombre: "Pagado",
    verde: { min: 0, max: 24 },
    amarillo: { min: 24, max: 48 },
    rojo: { min: 48, max: Infinity },
  },
};
